<!-- eslint-disable max-len -->
<template>
  <div class="row">
    <div v-if="loading">
      <blade-spinner />
    </div>
    <div class="col">
      <b-input-group style="width: 48%; font-size: 80%; margin: 0 0 8px;">
        <b-input-group-prepend style="padding: 8px 5px 5px; background-color: rgb(235,235,235); border-radius: 5px 0 0 5px;">
          Desired group size:
        </b-input-group-prepend>
        <b-input v-model="groupSizeTarget"/>
        <b-input-group-append>
          <button
            class="btn"
            @click.prevent="autoGroupStudents"
            style="font-size: 105%; margin: 0 0 3px; padding: 0 5px;"
          >
            Auto-Group Students
          </button>
        </b-input-group-append>
      </b-input-group>
      <div class="row">
        <div class="col-6">
          <h3>Groups</h3>
          <b-button
            @click="(ev) => addClassGroup(groupList.length)"
            style="padding: 0 5px; margin: 0 0 8px;"
          >
            Create Empty Group
          </b-button>
          <b-button
            @click="(ev) => startPendingGroups()"
            style="padding: 0 5px; margin: 0 0 8px;"
          >
            Start Pending Groups
          </b-button>
          <div
            style="overflow-y: auto; max-height: 60vh;"
          >
            <div
              class="list-group-item"
              v-for="(group, groupIndex) in groupList"
              :key="`group${groupIndex}`"
              style="position: relative;"
            >
              <h5>#{{groupIndex + 1}} &nbsp; <span style="font-size: 80%;">({{group.status}})</span></h5>
              <h6>{{group.name}}</h6>
              <b-button
                @click="(ev) => removeClassGroup(groupIndex)"
                :disabled="group.status !== 'pending'"
                style="padding: 0 5px; position: absolute; top: 5px; right: 8px; transform: scale(0.864);"
              >
                Delete Group
              </b-button>
              <div
                v-if="group.players.length === 0"
                style="font-size: 13px;"
              >
                Drag unassigned users below this text to<br>assign them to this group.
              </div>
              <draggable
                class="list-group"
                :list="group.players"
                group="people"
                @change="(ev) => onClassGroupChanged(group)"
                :disabled="group.status !== 'pending'"
              >
                <div
                  class="list-group-item"
                  v-for="(student, studentIndex) in group.players"
                  :key="`group${groupIndex}-${studentIndex}`"
                  style="font-size: 13px;"
                >
                  {{ student.email }}
                </div>
              </draggable>
            </div>
          </div>
        </div>

        <div class="col-6">
          <h3>Unassigned</h3>
          <draggable class="list-group" :list="unassignedList" group="people" @change="log">
            <div
              class="list-group-item"
              v-for="(unassigned, unassignedIndex) in unassignedList"
              :key="`unassigned${unassignedIndex}`"
              style="font-size: 13px;"
            >
              {{ unassigned.email }}
            </div>
          </draggable>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable';
import { mapActions } from 'vuex';

export default {
  components: {
    draggable
  },
  props: {
    activeClass: { type: Object },
    users: { type: Array }
  },
  data() {
    return {
      loading: false,
      groupSizeTarget: 5,
      groupList: [
      ],
      unassignedList: [
      ]
    };
  },
  methods: {
    ...mapActions([
      'getClassGroups',
      'createClassGroup',
      'updateClassGroup',
      'deleteClassGroup',
    ]),
    async autoGroupStudents() {
      try {
        for (let si = 0; si < this.unassignedList.length;) {
          const s = this.unassignedList[si];
          let needNewGroup = true;
          for (let gi = 0; gi < this.groupList.length; ++gi) {
            const g = this.groupList[gi];
            if (g.status === 'pending' && g.players.length < this.groupSizeTarget) {
              g.players.push(s);
              const found = this.unassignedList.findIndex(({ _id }) => `${_id}` === `${s._id}`);
              this.unassignedList.splice(found, 1);
              await this.updateClassGroup(g);
              needNewGroup = false;
              break;
            }
          }
          if (needNewGroup) {
            const g = await this.addClassGroup(this.groupList.length);
            if (g != null) {
              g.players.push(s);
              const found = this.unassignedList.findIndex(({ _id }) => `${_id}` === `${s._id}`);
              this.unassignedList.splice(found, 1);
              await this.updateClassGroup(g);
            }
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async startPendingGroups() {
      try {
        for (let gi = 0; gi < this.groupList.length; ++gi) {
          const g = this.groupList[gi];
          if (g.status === 'pending') {
            g.status = 'started';
            await this.updateClassGroup(g);
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async addClassGroup(index) {
      try {
        const g = await this.createClassGroup({
          name: `${this.activeClass.courseName} Group ${index + 1}`,
          activeClass: this.activeClass._id,
          game: this.activeClass.game,
          players: []
        });
        this.groupList.push(g);
        return g;
      } catch (err) {
        console.log(err);
        return null;
      }
    },
    async removeClassGroup(index) {
      const r = this.groupList.splice(index, 1);
      if (r == null || r.length === 0) return;
      const g = r[0];

      if (g.players != null) {
        for (let pi = 0; pi < g.players.length; ++pi) {
          this.unassignedList.push(g.players[pi]);
        }
      }

      try {
        await this.deleteClassGroup({ groupId: g._id });
      } catch (err) {
        console.log(err);
      }
    },
    async onClassGroupChanged(group) {
      try {
        await this.updateClassGroup(group);
      } catch (err) {
        console.log(err);
      }
    },
    initUserAssignment(user) {
      const test = `${user._id}`;
      for (let gi = 0; gi < this.groupList.length; ++gi) {
        const g = this.groupList[gi];
        if (g != null && g.players != null) {
          for (let pi = 0; pi < g.players.length; ++pi) {
            const p = g.players[pi];
            if (`${p._id}` === test) {
              p.email = user.email;
              p.firstName = user.firstName;
              p.lastName = user.lastName;
              return;
            }
          }
        }
      }
      this.unassignedList.push(user);
    },
    isUserAssigned(user) {
      const test = `${user._id}`;
      return this.groupList.some(g => g != null && g.players != null && g.players.some(p => `${p._id}` === test));
    },
    log(evt) {
      console.log(evt);
    }
  },
  async mounted() {
    this.loading = true;
    try {
      this.groupList = await this.getClassGroups(this.activeClass._id);
      this.unassignedList.length = 0;
      this.users.forEach(this.initUserAssignment);
    } catch (err) {
      console.log(err);
    }
    this.loading = false;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/blade/pages/components/GroupManager.vue